import React from 'react';
import { useSelector } from 'react-redux';
import '../Style/Loading.css';

const Loading = ({ loading: localLoading, fullScreen = true, overlay = false }) => {
    // Get global loading state from Redux
    const globalLoading = useSelector((state) => state.Loading?.loading);
    
    // Use local loading if provided, otherwise use global loading
    const isLoading = localLoading !== undefined ? localLoading : globalLoading;

    if (!isLoading) return null;

    if (!fullScreen || overlay) {
        const overlayClass = overlay === 'table' ? "loader-overlay-table" : "loader-overlay-regional";
        return (
            <div className={overlay ? overlayClass : "loader-container-local"}>
                <div className={overlay ? "loader" : "loader loader-local"}></div>
            </div>
        );
    }

    return (
        <div className="loader-overlay">
            <div className="loader"></div>
        </div>
    );
};

export default Loading;